import React from 'react';
import PreloadLink from './PreloadLink';
import classnames from 'classnames';

class ProjectsArchive extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeEntry: null,
      imageActive: false,
      mouseX: 0,
      mouseY: 0,
    };

    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
  }

  handleResize = () => {
    // Handle resize logic if needed
    const archive = document.querySelector('.PortfolioOutro-archive');
    const site = document.querySelector('.Site');
    let height = window.innerHeight;
    if (archive && site) {
      height = archive.offsetHeight;
      site.style.setProperty('--archive-height', `${height}px`);
    }
  };

  timer = null;

  handleEnter = (entry) => {
    clearTimeout(this.timer);
    this.setState({ activeEntry: entry });
    setTimeout(() => {
      this.setState({ imageActive: true });
    }, 100);
  };
  handleLeave = () => {
    this.setState({ imageActive: false });
    this.timer = setTimeout(() => {
      this.setState({ activeEntry: null });
    }, 100);
  };

  handleMouseMove = (e) => {
    this.setState({
      mouseX: e.clientX,
      mouseY: e.clientY,
    });
  };

  componentDidMount() {
    // Fetch or initialize data if needed
    document.addEventListener('mousemove', this.handleMouseMove);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // Cleanup if necessary
    document.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const cls = classnames('ProjectsArchive', {
      'ProjectsArchive--active': this.props.active,
    });

    const { projects } = this.props;

    if (!projects) {
      return null;
    }

    const { activeEntry, imageActive } = this.state;

    const imageCls = classnames('ProjectsArchive-image', {
      active: imageActive,
    });
    const style = {
      transform: `translate(-50%, calc(${this.state.mouseY}px - 50%))`,
      left: '50%',
    };
    // const style = {
    //   transform: `translate(calc(${this.state.mouseX}px - 50%), calc(${this.state.mouseY}px - 50%))`,
    // };

    return (
      <div className={cls}>
        <div className="ProjectsArchive-body">
          <div className="Project-header">
            <span className="Project-item-title">Title</span>
            <span className="Project-item-client">Client</span>
            <span className="Project-item-sector">Sector</span>
          </div>
          {projects.map((project, ix) => (
            <div
              key={ix}
              className="Project-item Project-option"
              onMouseEnter={() => this.handleEnter(project)}
              onMouseLeave={() => this.handleLeave()}
            >
              <PreloadLink to={`/${project.slug}`}>
                <img
                  className="Project-item-thumb"
                  src={projects.thumbnail}
                  alt=""
                />
                <span className="Project-item-title">{project.title}</span>
                <span className="Project-item-client">{project.client}</span>
                <span className="Project-item-sector">{project.sector}</span>
              </PreloadLink>
            </div>
          ))}
        </div>
        <div className={imageCls} style={style}>
          {activeEntry && <img src={activeEntry.thumbnail} alt="" />}
        </div>
      </div>
    );
  }
}

export default ProjectsArchive;



// WEBPACK FOOTER //
// ./src/js/components/ProjectsArchive.jsx